/**
 * React's view of the console session in src/api/platformSession.ts.
 *
 * Separate from useSession for the same reason the session itself is: the two
 * surfaces must not be able to read each other's state by accident.
 */

import { useSyncExternalStore } from "react";

import { getWho, isSignedIn, subscribe } from "./api/platformSession";

interface PlatformSessionView {
  signedIn: boolean;
  who: string | null;
}

// Compared by identity, so this is rebuilt only when something changed.
let snapshot: PlatformSessionView = { signedIn: isSignedIn(), who: getWho() };

function read(): PlatformSessionView {
  const signedIn = isSignedIn();
  const who = getWho();
  if (snapshot.signedIn !== signedIn || snapshot.who !== who) {
    snapshot = { signedIn, who };
  }
  return snapshot;
}

export function usePlatformSession(): PlatformSessionView {
  return useSyncExternalStore(subscribe, read, read);
}
